// router.js
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import OngoingProjects from "./pages/OngoingProjects";
import CompletedProjects from "./pages/CompletedProjects";
import ProposedProjects from "./pages/ProposedProjects";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import ContactUs from "./pages/ContactUs";
import Layout from "./components/Layout";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "projects/ongoing", element: <OngoingProjects /> },
      { path: "projects/completed", element: <CompletedProjects /> },
      { path: "projects/proposed", element: <ProposedProjects /> },
      { path: "projects/:id", element: <ProjectDetailsPage /> }, // Add this route
      { path: "contact", element: <ContactUs /> },
      { path: "admin/login", element: <AdminLogin /> },
      { path: "admin", element: <AdminDashboard /> },
      {
        path: "*",
        element: <div style={{ padding: 24 }}>Page not found.</div>,
      },
    ],
  },
]);
